/******/ (() => { // webpackBootstrap
/*!********************************************!*\
  !*** ./zrc/scripts/general/page-loaded.js ***!
  \********************************************/
function pageLoaded() {
  var hiddenContainer = document.querySelectorAll('.js-page-loaded');
  window.setTimeout(() => {
    for (var contentIteration = 0; contentIteration < hiddenContainer.length; contentIteration++) {
      hiddenContainer[contentIteration].classList.remove('is-not-loaded');
    }
  }, 300);
}
window.addEventListener('load', () => {
  pageLoaded();
});
document.addEventListener('shopify:section:load', () => {
  pageLoaded();
});
/******/ })()
;